import { CONFIG } from '@frameio/config';
import { getLink } from '.';

// Note: https://local-integrations.dev.frame.io is intentionally replaced with
// https://next.dev.frame.io instead of https://local.dev.frame.io in order to
// avoid having to run 2 local servers simultaneously.

export const getV4AppServerOriginFromIntegrations = () => {
  return CONFIG.appServerOrigin.replace(
    /https?:\/\/.*integrations\./i,
    'https://next.'
  );
};

export const getV4LinkFromIntegrations = (href: string) => {
  return `${getV4AppServerOriginFromIntegrations()}${href}`;
};

export const getV4WorkspaceURLFromIntegrations = (accountId?: string) => {
  const url = getV4AppServerOriginFromIntegrations();

  return `${url}${getLink({ page: 'workspaces', accountId })}`;
};
